/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Copilot_DescInputs */



/**
* | output |
* | --- |
* | "AI-powered EU AI Act risk detection. Real-time classification of chat messages for compliance violations." |
*
* @param {Sub_Addons_Copilot_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_copilot_desc = /** @type {((inputs?: Sub_Addons_Copilot_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Copilot_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-gestützte EU-AI-Act-Risikoerkennung. Echtzeit-Klassifizierung von Chat-Nachrichten auf Compliance-Verstöße.")
	return /** @type {LocalizedString} */ ("AI-powered EU AI Act risk detection. Real-time classification of chat messages for compliance violations.")
});